/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TemplatesInputs */

const en_nav_templates = /** @type {(inputs: Nav_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

const he_nav_templates = /** @type {(inputs: Nav_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תבניות`)
};

/**
* | output |
* | --- |
* | "Templates" |
*
* @param {Nav_TemplatesInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const nav_templates = /** @type {((inputs?: Nav_TemplatesInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TemplatesInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_templates(inputs)
	return he_nav_templates(inputs)
});